import React, {
  createContext,
  useEffect,
  useReducer,
  useState
} from 'react';
import SplashScreen from 'src/components/SplashScreen';
import axios from 'axios';
import { apiBaseURL } from '../system/Constants/API.js';
import _ from 'underscore';

const initialCASState = {
  isFloat: false,
};

const setSessionFloat = (float) => {
  if (float) {
    localStorage.setItem('float', JSON.stringify(float));
  } else {
    localStorage.removeItem('float');
  }
}

/**
 * Get selected user
 * @param {*} param0
 * @returns branchObject from localstorage
 */
 const getSelectedUser = () => {
  return JSON.parse(localStorage.getItem('user'));
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'INITIALISE': {
      const { isFloat } = action.payload;

      return {
        ...state,
        isFloat: true,

      };
    }
    case 'FLOAT': {
      const { float } = action.payload;

      return {
        ...state,
        isFloat: true,
        float
      };
    }

    case 'CASHUP': {
      return {
        ...state,
        isFloat: false,
        float: null
      };
    }

    case 'NOFLOAT': {
      return {
        ...state,
        isFloat: false,
        float: null
      };
    }
   
    default: {
      return { ...state };
    }
  }
};

const CloudAppSessionContext = createContext({
  ...initialCASState,
  // method: 'JWT',
  // getFloat: () => Promise.resolve(),
  // logout: () => { },
  // register: () => Promise.resolve()
});

const getFloatId = async () => {
    const user = await getSelectedUser();
    let response;
    try {
      response = await axios.get(
        `${apiBaseURL}/api/v1/monies/floatid/${user._id}`
      );
      console.log('response.data.data.floatId', response.data.data.floatId);
      return response.data.data.floatId;
    } catch (error) {
      console.log(error)
    }
}

const getFloatDoc = async (floatId) => {
  try {
    const response = await axios.get(
      `${apiBaseURL}/api/v1/monies/float/${floatId}`
    );
    return response.data.doc;
  } catch (error) {
    console.log(error)
  }
}

export const CASProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialCASState);
  const [float, setFloat] = useState({});

  const getFloat = async () => {

    const floatId = await getFloatId();
    console.log('floatId', floatId);

    if (floatId && floatId !== null) {
    
      const floatDoc = await getFloatDoc(floatId);

      //console.log('[CloudAppContext][floatDoc]',floatDoc);

      if (floatDoc == null) {
        dispatch({
          type: 'NOFLOAT'
        });
        return null;
      }

      const float = {
        id: floatDoc._id,
        branch: floatDoc.branch,
        cashRegister: floatDoc.cashRegister,
        user: floatDoc.user,
      };

      setSessionFloat(float);
      dispatch({
        type: 'FLOAT',
        payload: {
          float
        }
      });
    } else if (floatId === null || floatId === undefined) {
      dispatch({
        type: 'NOFLOAT'
      });
    }
  };

  // const logout = () => {
  //   setSession(null);
  //   setSessionBranch(null);
  //   dispatch({ type: 'LOGOUT' });
  // };

  // const register = async (email, name, password) => {
  //   const response = await axios.post('/api/account/register', {
  //     email,
  //     name,
  //     password
  //   });
  //   const { accessToken, user } = response.data;

  //   window.localStorage.setItem('accessToken', accessToken);

  //   dispatch({
  //     type: 'REGISTER',
  //     payload: {
  //       user
  //     }
  //   });
  // };

  useEffect(() => {
    const initialise = async () => {

      try {
        const float = await window.localStorage.getItem('float');

        if (_.isEmpty(float)) {
          getFloat();
        }

        if (float) {
          dispatch({
            type: 'INITIALISE',
            payload: {
              isFloat: true,
              float
            }
          });
        } else {
          dispatch({
            type: 'INITIALISE',
            payload: {
              isFloat: false,
              float: null
            }
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALISE',
          payload: {
            isFloat: false,
            float: null
          }
        });
      }
    };
    initialise();
  }, []);

  return (
    <CloudAppSessionContext.Provider
      value={{
        ...state,
        getFloat,
      }}
    >
      {children}
    </CloudAppSessionContext.Provider>
  );
};

export default CloudAppSessionContext;